import React from 'react';
import { CLIENT_DETAILS_PAGE, MEMBERS_PAGE } from '../constants';
import { RouteContext } from '../context';
import { useKeyboardShortcutsV2 } from './useKeyboardShortcutsV2';
import useNavigate from './useNavigate';
import { useUserCanInvite } from './useUserCanInvite';

export const useInviteMemberCommandAction = () => {
  const { pathname } = React.useContext(RouteContext);
  const { navigate } = useNavigate();
  const { isUserCanInvite } = useUserCanInvite();

  // setup invite team member command action if user has permission
  useKeyboardShortcutsV2(
    isUserCanInvite
      ? [
          {
            id: 'invite-team-member-action',
            name: 'Invite team member',
            perform: () =>
              navigate(`${MEMBERS_PAGE.path}?openInviteModal=true`),
            section: pathname.includes(CLIENT_DETAILS_PAGE.path)
              ? 'General'
              : undefined,
          },
        ]
      : [],
  );
};
